import React from "react";

const isTournamentRoute = () => {
  if (typeof window === "undefined") return false;
  const route = `${window.location.pathname}${window.location.hash}`;
  return route.includes("/tournament") || route.includes("/rooms");
};

const Loader = () => {
  if (isTournamentRoute()) return null;

  return (
    <div className="app-loader app-loader--skeleton" role="status" aria-live="polite">
      <div className="app-loader__backdrop" />
      <div className="app-loader__skeleton-shell" aria-label="Loading">
        <div className="app-loader__skeleton-hero">
          <span className="app-loader__skeleton-line app-loader__skeleton-line--eyebrow" />
          <span className="app-loader__skeleton-line app-loader__skeleton-line--title" />
          <span className="app-loader__skeleton-line app-loader__skeleton-line--copy" />
          <span className="app-loader__skeleton-line app-loader__skeleton-line--short" />
        </div>
        <div className="app-loader__skeleton-grid">
          <span />
          <span />
        </div>
        <div className="app-loader__skeleton-body">
          <div className="app-loader__skeleton-panel">
            <span className="app-loader__skeleton-line app-loader__skeleton-line--eyebrow" />
            <span className="app-loader__skeleton-line app-loader__skeleton-line--heading" />
            <span className="app-loader__skeleton-line app-loader__skeleton-line--copy" />
            <div className="app-loader__skeleton-cards">
              <span />
              <span />
            </div>
          </div>
          <div className="app-loader__skeleton-side">
            <span className="app-loader__skeleton-line app-loader__skeleton-line--heading" />
            <span className="app-loader__skeleton-line app-loader__skeleton-line--copy" />
            <span className="app-loader__skeleton-card" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
